var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "200px" } },
    [
      _c(
        "el-table",
        {
          attrs: {
            data: _vm.FileTree,
            "tree-props": _vm.defaultProps,
            "row-key": "id"
          }
        },
        [_c("el-table-column", { attrs: { prop: "title", label: "名称" } })],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }